import { DEFAULT_PII_FIELDS } from './pii';

const packageSettings = require('../package.json');

export const INITIAL_STATE = {
	provider: 'konnektive',
	version: packageSettings.version || 'no_identified',
	debugMode: 0,
	enableAutoLog: 0,
	checkoutErrorsCountToSendError: 5,
	instance: "offerpage",
	// Service endpoints match konnektive-engine ver-4 (0.4.11): the retired
	// lambda.token-fetch-envisia.com hosts are replaced by API Gateway routes,
	// and services with no gateway route are '' — every caller skips an empty
	// URL instead of firing a request at the current page.
	// Sticky-only; nothing on the Konnektive path calls it.
	domain: '',
	apiVersion: 'api/v1',
	api2Version: 'api/v2',
	legacyAPIURL: '',
	redtrackURL: 'https://api-gateway.envisiagroup.com/send-redtrack',
	getIPURL: 'https://api-gateway.envisiagroup.com/get-ip',
	contactFormURL: '',
	errorDebugURL: '',
	// The proxy only answers origins on its allowlist. A funnel whose host is
	// not on it gets every Konnektive call blocked by the browser (CORS).
	konnektiveAPIURL: 'https://api-gateway.envisiagroup.com/konnektive-proxy',
	// Checkout-gateway (bot protection). Off by default: a funnel opts in by
	// setting checkoutGatewayURL in its OPconfig, and then click -> lead ->
	// order -> upsell go through the gateway instead of konnektiveAPIURL.
	// The gateway must allow the funnel's host, or every checkout fails.
	checkoutGatewayURL: '',
	// Cloudflare Turnstile, sent with gateway orders only. Site key is public;
	// the secret stays on the gateway. The gateway's per-session mode
	// (on / watch / off) overrides turnstileEnabled when it sends one.
	turnstileEnabled: false,
	turnstileSiteKey: '',
	// Query goes straight after the path: '/get-shipping-zip/?zip=' is a 404.
	zipDetectURL: 'https://api-gateway.envisiagroup.com/get-shipping-zip',
	emailValidationURL: 'https://app.datashuttle.co/api/validation/email',
	phoneValidationURL: 'https://app.datashuttle.co/api/validation/phone_number',
	kountMerchantID: '201615',
	kountMerchantIDKonnektive: '132900',
	useKount: true,
	rtPostbacks: true,
	rtDomain: 'trk.bit-bytes.net',
	
	shippingPrice: 5.95,
	shippingPriceIntl: 19.95,
	discountOneTime: 0,
	discountSubscribe: 25,

	shippingProtectionID: 37,
	shippingProtectionShippingID: 2, // should be 0 cost
	shippingProtectionBillingModelID: 2, // should be 1 time shipment
	testGatewayID: 1,

	// ZIP/country config — replaces script-tag attribute reads (task 7b)
	zipCityPlaceholder: '',
	zipFeedback: false,
	countries: '',
	countriesExcept: '',

	enableUpsells: true,

	// How customer details cross the shipping -> checkout hop.
	//   'session' (default) — stash them in sessionStorage, keep them out of
	//                         the URL. The flow already hard-depends on
	//                         sessionStorage (konnektiveSessionID, lead data),
	//                         so this adds no new failure mode.
	//   'query'             — legacy native GET submit; every field lands in
	//                         the checkout URL. Kill switch, not a feature.
	urlPiiTransport: 'session',

	// Fields withheld from the URL under 'session'. Replaces the default list
	// wholesale when a funnel sets it, same as passThruParams.
	piiFields: DEFAULT_PII_FIELDS,

	// Two-page funnels: keep a partial lead fresh on every shipping-field blur,
	// the way one-page checkouts already do. Opt-in — it issues a
	// /leads/import call per blur.
	quickLeadOnBlur: false,

	// Extension for in-funnel links. Hosts that serve extensionless routes
	// (Cloudflare Workers Assets, Netlify, Vercel) set '' so the engine stops
	// emitting links that only resolve via a host redirect.
	pageExtension: '.html',

	passThruParams: [
		"clickid",
		"msclkid",
		"refd",
		"trk"
	],


	blockedCardNumbers: [
		"5555555555554444",
		"4111111111111111"
	],

	productName: '',
	companyName: 'Herbal Research',

	onlinePhoneValidation: false,
	onlineEmailValidation: false,
	suggestEmail: false,

	shipProtection: [{
		pid: 37,
		shippingID: 2,
		billingModelID: 2,
	}],

	gifts: [{
		pid: 23, // Sleep Mask
		campaignID: 21,
		offerID: 5,
		shippingID: 2,
		billingModelID: 2,
	}],

	billingModels: [{
			id: 6,
			name: 'Every 5 Months',
		},
		{
			id: 5,
			name: 'Every 3 Months',
		},
		{
			id: 3,
			name: 'Every 1 Month',
		},
	],
	authHeaders: {
		'Content-Type': 'application/json',
		'X-SESSION-ID': localStorage.getItem('session_id')
	},
};

export const getCookieValue = (name) => {
	const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
	if (match) return match[2];
	return '';
};

export const setCookieValue = (name, value, expireTimeString = '') => {
	document.cookie = `${name}=${value};path=/;${expireTimeString}`;
};

export const setLocalStorage = (key, value) => {
	let content = value;
	if (typeof content !== 'string') {
		content = JSON.stringify(content);
	}
	localStorage.setItem(key, content);
};

export const getLocalStorage = (key) => {
	try {
		const content = localStorage.getItem(key);
		const parsed = JSON.parse(content);
		if (parsed && typeof parsed === 'string') {
			return parsed;
		}
		if (parsed && typeof parsed === 'object') {
			return parsed;
		}
		return '';
	} catch (e) {
		return localStorage.getItem(key);
	}
};

export const setSessionStorage = (key, value) => {
	let content = value;
	if (content !== 'string') {
		content = JSON.stringify(content);
	}
	sessionStorage.setItem(key, content);
};

export const getSessionStorage = (key) => {
	try {
		const content = sessionStorage.getItem(key);
		const parsed = JSON.parse(content);
		if (parsed && typeof parsed === 'string') {
			return parsed;
		}
		if (parsed && typeof parsed === 'object') {
			return parsed;
		}
		return '';
	} catch (e) {
		return '';
	}
};

export const deleteSessionStorage = (key) => sessionStorage.removeItem(key);

// Operation config lives in memory, for the lifetime of the page.
//
// It used to be persisted to localStorage under a single key, which caused two
// problems. localStorage is per-ORIGIN, so every funnel on a domain shared one
// config: browsing /apgt1 (campaign 219) and then the root funnel (campaign
// 129) left the first funnel's keys in place, because init() merged over
// whatever the previous funnel wrote. And since config now loads async, there
// was a window on every page load where getConfig() returned the PREVIOUS
// funnel's config — long enough to book an order against the wrong campaign.
//
// Nothing needs it to survive a navigation: config is re-derived from
// OPconfig.js on every page, and upsellIndex is set per page from the URL. An
// empty config before init() is also the safer failure — it falls back to
// defaults or fails visibly, rather than silently using another funnel's
// campaign.
//
// The old key was '@konnektive-engine', which the previous framework also
// used, so a page-by-page migration would have had both engines writing the
// same key with different config shapes. Keeping this off storage entirely
// removes that collision too.
let configState = {};

export const getConfig = () => configState;

// Still merges: render.js updates a single key (upsellIndex) mid-page, and
// init() passes a whole config built from INITIAL_STATE + the funnel's
// OPconfig, so a merge and a replace are equivalent there.
export const setConfig = (value) => {
	configState = {
		...configState,
		...value,
	};
};

// Test seam — drops the in-memory config so a suite can start from a known
// state.
//
// Note it IS reachable from funnel pages: index.js spreads every config export
// onto window, so this lands there as window.resetConfig(). Since 1.2.0 the
// in-memory object is the only copy — there is no localStorage fallback to
// re-read — so calling it on a live page blanks the config until the next load.
// Nothing should call it outside tests.
export const resetConfig = () => {
	configState = {};
};